import React, { useState } from 'react';
import { 
  Mail, 
  MapPin, 
  Clock,
  Instagram,
  Copy
} from 'lucide-react';
import { trackNavigationClick } from './GoogleAnalytics';

const Footer: React.FC = () => {
  const [showToast, setShowToast] = useState(false);


  const scrollToSection = (sectionId: string) => {
    // Track navigation click
    trackNavigationClick(sectionId);
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openInstagram = () => {
    window.open('https://instagram.com/katiahondafisio', '_blank');
  };

  return (
    <>
      {/* Toast */}
      {showToast && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-[60] animate-fade-in">
          Email copiado para a área de transferência!
        </div>
      )}
      
      <footer className="bg-gray-900 text-white">
      {/* Seção principal do footer */}
      <div className="py-16 px-6 sm:px-8 sm:py-20 lg:py-24">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 sm:gap-12">
            {/* Informações da empresa */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-heading font-bold text-white mb-3">
                  Dra. Katia Honda
                </h3>
                
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
                  Fisioterapeuta<br />Crefito-3 401508-F
                </p>
              </div>
              
              {/* Redes sociais */}
              <div>
                <h4 className="text-sm sm:text-base font-semibold text-white mb-4">Siga-nos</h4>
                <div className="flex space-x-4">
                  <button
                    onClick={openInstagram}
                    className="w-14 h-14 sm:w-16 sm:h-16 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 transition-all duration-300 min-h-[48px]"
                    aria-label="Instagram @katiahondafisio"
                  >
                    <Instagram className="w-6 h-6 sm:w-7 sm:h-7" />
                  </button>
                </div>
              </div>
            </div>

            {/* Links rápidos */}
            <div>
              <h4 className="text-sm sm:text-base font-semibold text-white mb-5">Links Rápidos</h4>
              <ul>
                <li>
                  <button
                    onClick={() => scrollToSection('inicio')}
                    className="text-sm sm:text-base text-gray-300 hover:text-primary-200 transition-colors duration-300 text-left flex items-center"
                  >
                    Início
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('sobre')}
                    className="text-sm sm:text-base text-gray-300 hover:text-primary-200 transition-colors duration-300 text-left flex items-center"
                  >
                    Sobre
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('servicos')}
                    className="text-sm sm:text-base text-gray-300 hover:text-primary-200 transition-colors duration-300 text-left flex items-center"
                  >
                    Serviços
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('contato')}
                    className="text-sm sm:text-base text-gray-300 hover:text-primary-200 transition-colors duration-300 text-left flex items-center"
                  >
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            {/* Informações de contato */}
            <div>
              <h4 className="text-sm sm:text-base font-semibold text-white mb-5">E-mail</h4>
              <div className="space-y-5">
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 sm:w-6 sm:h-6 text-primary-200 flex-shrink-0" />
                  <a 
                    href="mailto:contato@katiahondafisio.com.br"
                    className="text-xs sm:text-sm text-gray-300 hover:text-primary-200 transition-colors leading-relaxed"
                  >
                    contato@katiahondafisio.com.br
                  </a>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText('contato@katiahondafisio.com.br');
                      setShowToast(true);
                      setTimeout(() => setShowToast(false), 3000);
                    }}
                    className="p-2 hover:bg-gray-700 rounded transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
                    title="Copiar e-mail"
                  >
                    <Copy className="w-4 h-4 text-gray-300" />
                  </button>
                </div>
                <div>
                  <h5 className="text-sm sm:text-base font-medium text-white mb-3">Atendimento</h5>
                  <div className="flex items-start space-x-3 mb-4">
                    <MapPin className="w-5 h-5 sm:w-6 sm:h-6 text-primary-200 flex-shrink-0 mt-1" />
                    <span className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                      <strong>Zona Sul de São Paulo:</strong><br />
                      Jabaquara, São Judas, Conceição,<br />
                      Saúde, Vila Mariana e regiões próximas
                    </span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-primary-200 flex-shrink-0 mt-1" />
                    <div className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                      <div>Segunda à sexta: 15h às 19h</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to action */}
      {/* <div className="bg-primary-600 py-8">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-center md:text-left mb-4 md:mb-0">
              <h4 className="text-xl font-semibold text-white mb-2">
                Pronto para iniciar seu tratamento?
              </h4>
              <p className="text-primary-100">
                Entre em contato agora e agende sua avaliação.
              </p>
            </div>
            <a
              href="mailto:contato@katiahondafisio.com.br?subject=Agendamento de Consulta&body=Olá Dra. Katia! Gostaria de agendar uma consulta de fisioterapia e/ou Pilates."
              className="bg-white text-primary-600 font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-300 flex items-center space-x-2"
            >
              <Mail className="w-5 h-5" />
              <span>Enviar E-mail</span>
            </a>
          </div>
        </div>
      </div> */}

      {/* Copyright */}
      {/* <div className="bg-gray-800 py-6">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <span>© {currentYear} Dra. Katia Honda Fisioterapia e Pilates.</span>
              <span>Todos os direitos reservados.</span>
            </div>            
          </div>
        </div>
      </div> */}
      </footer>
    </>
  );
};

export default Footer;